const HEIGHT_PROPERTY = '--mg-page-message-height';
const MESSAGE_SELECTOR = '.mg-page-message';

/**
 * PageMessageService exposes the real height of the fixed top message bar
 * as a CSS custom property, so the navbar and content offsets follow it.
 */
class PageMessageService {
  static getMessages() {
    return Array.from(document.querySelectorAll(MESSAGE_SELECTOR));
  }
  static getHeight() {
    return PageMessageService.getMessages().reduce((height, message) => Math.max(height, message.offsetHeight), 0);
  }
  static syncHeight() {
    const height = PageMessageService.getHeight();
    if (height > 0) {
      document.documentElement.style.setProperty(HEIGHT_PROPERTY, `${height}px`);
    } else {
      document.documentElement.style.removeProperty(HEIGHT_PROPERTY);
    }
  }
  static trackHeight() {
    const messages = PageMessageService.getMessages();
    const clear = () => document.documentElement.style.removeProperty(HEIGHT_PROPERTY);
    PageMessageService.syncHeight();
    if (messages.length === 0 || typeof ResizeObserver === 'undefined') {
      return clear;
    }
    const observer = new ResizeObserver(() => PageMessageService.syncHeight());
    messages.forEach(message => observer.observe(message));
    return () => {
      observer.disconnect();
      clear();
    };
  }
}
export default PageMessageService;